import MaterialPropertyAssigner from "../../../output/assets/materials/material-property-assigner.js";

class ThreeMaterialColorAssigner extends MaterialPropertyAssigner {
    constructor(defaultValues) {
        super();

        this._defaultValues = defaultValues;
    }

    setProperty(material, property, value) {
        if (value === undefined) {
            value = this._defaultValues[property];
        }

        if (typeof(value) === "string") {
            value = value.trim();

            const hexMatch = value.match(/^0x([0-9A-Fa-f]+)$/);
            if (hexMatch) {
                value = "#"+hexMatch[1];
            }
        }

        material[property].set(value);
    }
}

export default ThreeMaterialColorAssigner;
